import {iImageData, iImageObj} from './interfaces'
import { SLIDESHOWS, TECH_CATEGORY, SITE_CLIENT, GLOBALS } from '../types'

export default class SlideshowManager { // TODO change to ObjSlideshow
  slideshowsDictionary: {[index: string]:SlideshowObj}
  // get: (key:string): slideshowObj = {}
  constructor () {
    this.slideshowsDictionary = {}
  }

  public addSlideshow (key:string, slideshowObj:SlideshowObj): SlideshowObj {
    this.slideshowsDictionary[key] = slideshowObj
    return (this.get(key))
  }

  get (key:string): SlideshowObj {
    return (this.slideshowsDictionary[key])
  }

  lazyLoad () {
    if (Object.keys(this.slideshowsDictionary).length === 0) {
      this.load()
    }
  }

  public load () {
    let slideshow = this.addSlideshow(SLIDESHOWS.logos, new SlideshowObj(SLIDESHOWS.logos, 190, 150, SLIDESHOWS.logos, 'Supported Tech', GLOBALS.slideshowTransition))
    const techUrl = '/tech/list'
    slideshow.addSlide('auth0.png', { category: TECH_CATEGORY.identity, url: techUrl })
    slideshow.addSlide('AWSCloudformation.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSCloudwatch.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSCognito.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSEventbridge.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSIAM.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('AWSS3.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSSecretsManager.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSecr.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('AWSlambda.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('AWSsqs.png', { category: TECH_CATEGORY.cloud_computing, url: techUrl })
    slideshow.addSlide('adyen.png', { category: TECH_CATEGORY.ecommerce, url: techUrl })
    slideshow.addSlide('ajax.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('amazonAWS.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('amazonEC2.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('amazonSES.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('angularJS.jpg', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('aws-cli.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('axios.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('azure.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('babel.png', { category: TECH_CATEGORY.javascript, url: techUrl })
    slideshow.addSlide('bash.png', { category: TECH_CATEGORY.language, url: techUrl })
    slideshow.addSlide('bitbucket.png', { category: TECH_CATEGORY.code_versioning, url: techUrl })
    slideshow.addSlide('bootstrap.png', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('browserstack.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('centos.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('chai.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('confluence.jpg', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('chromeDevTools.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('codepen.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('css3.jpg', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('curl.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('cypress.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('datadog.png', { category: TECH_CATEGORY.code_quality, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('datagrip.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('dBeaver.png', { category: TECH_CATEGORY.database, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('dbvisualizer.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('django.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('docker.png', { category: TECH_CATEGORY.deployment, url: techUrl })
    slideshow.addSlide('es6.png', { category: TECH_CATEGORY.javascript, url: techUrl })
    slideshow.addSlide('eslint.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('eureqa.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('express.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('faker-js.png', { category: TECH_CATEGORY.code_quality, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('fast-api.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('figma.png', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('firebase.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('flexbox.png', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('formik.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('gimp2.png', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('git.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('gitlab.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('github.jpg', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('gitpod.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('givex.png', { category: TECH_CATEGORY.ecommerce, url: techUrl })
    slideshow.addSlide('googlehangouts.png', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('handlebars.png', { category: TECH_CATEGORY.templating, url: techUrl })
    slideshow.addSlide('helmet.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('homebrew.png', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('html5.jpg', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('husky.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('intellijidea.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('internJS.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('jasmine.jpg', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('java2.jpg', { category: TECH_CATEGORY.language, url: techUrl })
    slideshow.addSlide('javascript.jpg', { category: TECH_CATEGORY.language, url: techUrl })
    slideshow.addSlide('jenkins.png', { category: TECH_CATEGORY.deployment, url: techUrl })
    slideshow.addSlide('jest.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('jira.png', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('jetbrains.png', { category: TECH_CATEGORY.code_authoring, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('jmeter.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('jquery.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('jsfiddle.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('json.jpg', { category: TECH_CATEGORY.markup, url: techUrl })
    slideshow.addSlide('jsp3.jpg', { category: TECH_CATEGORY.templating, url: techUrl })
    slideshow.addSlide('jsreport.png', { category: TECH_CATEGORY.templating, url: techUrl })
    slideshow.addSlide('klarna.png', { category: TECH_CATEGORY.ecommerce, url: techUrl })
    slideshow.addSlide('launchdarkly.png', { category: TECH_CATEGORY.deployment, url: techUrl })
    slideshow.addSlide('leadfoot.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('lerna.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('less.png', { category: TECH_CATEGORY.presentation, url: techUrl })
    slideshow.addSlide('linux.png', { category: TECH_CATEGORY.operating_system, url: techUrl })
    slideshow.addSlide('lodash.png', { category: TECH_CATEGORY.javascript, url: techUrl })
    slideshow.addSlide('macos.png', { category: TECH_CATEGORY.operating_system, url: techUrl })
    slideshow.addSlide('markdown.png', { category: TECH_CATEGORY.markup, url: techUrl })
    slideshow.addSlide('materialUi.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('mercurial.png', { category: TECH_CATEGORY.code_versioning, url: techUrl })
    slideshow.addSlide('microsoftTeams.png', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('mocha.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('moment.png', { category: TECH_CATEGORY.javascript, url: techUrl })
    slideshow.addSlide('mongoDb.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('mongoDb-atlas.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('mongoDb-GridFS.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('mysql2.jpg', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('netsuite.png', { category: TECH_CATEGORY.ecommerce, url: techUrl })
    slideshow.addSlide('nextjs.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('nexus.png', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('nginx.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('nightwatch.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('nodeJS.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('npm.png', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('nvm.png', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('okta.png', { category: TECH_CATEGORY.identity, url: techUrl })
    slideshow.addSlide('openID.png', { category: TECH_CATEGORY.identity, url: techUrl })
    slideshow.addSlide('oracle2.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('passportJs.png', { category: 'Security', url: techUrl })
    slideshow.addSlide('paypal.png', { category: TECH_CATEGORY.ecommerce, url: techUrl })
    slideshow.addSlide('perl.png', { category: TECH_CATEGORY.language, url: techUrl })
    slideshow.addSlide('pgadmin.png', { category: TECH_CATEGORY.database, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('php.png', { category: TECH_CATEGORY.templating, url: techUrl })
    slideshow.addSlide('plnkr.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('postgresql.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('postman.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('prettier.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('pycharm.png', { category: TECH_CATEGORY.server, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('python.png', { category: TECH_CATEGORY.server, url: techUrl }) // hard to read
    slideshow.addSlide('python-virtualenv.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('quasarWhite.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('react.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('react-hook-form.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('react-router.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('react-testing-library.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('redux.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('redux-toolkit.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('rest.png', { category: TECH_CATEGORY.networking, url: techUrl })
    slideshow.addSlide('rosetta.png', { category: TECH_CATEGORY.operating_system, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('selenium.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('saml.png', { category: TECH_CATEGORY.identity, url: techUrl })
    slideshow.addSlide('sequelize.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('ses.png', { category: TECH_CATEGORY.server, url: techUrl })
    slideshow.addSlide('slack.png', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('sqlite.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('sqlserver.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('sourcetree.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('split-io.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('storybook.png', { category: TECH_CATEGORY.collaboration, url: techUrl })
    slideshow.addSlide('styled-components.png', { category: TECH_CATEGORY.code_quality, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('swagger.png', { category: TECH_CATEGORY.database, url: techUrl })
    slideshow.addSlide('typescript.png', { category: TECH_CATEGORY.code_versioning, url: techUrl })
    slideshow.addSlide('vagrant.png', { category: TECH_CATEGORY.operating_system, url: techUrl })
    slideshow.addSlide('vim.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('visualStudioCode.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('virtualbox.png', { category: TECH_CATEGORY.operating_system, url: techUrl })
    slideshow.addSlide('vueJsWhite.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('webComponents.png', { category: TECH_CATEGORY.front_end_framework, url: techUrl })
    slideshow.addSlide('webpack.jpg', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('webstorm.png', { category: TECH_CATEGORY.code_authoring, url: techUrl })
    slideshow.addSlide('xml.png', { category: TECH_CATEGORY.markup, url: techUrl, width: 150, height: 190 })
    slideshow.addSlide('xslt.jpg', { category: TECH_CATEGORY.templating, url: techUrl })
    slideshow.addSlide('yarn.png', { category: TECH_CATEGORY.build, url: techUrl })
    slideshow.addSlide('yup.png', { category: TECH_CATEGORY.code_quality, url: techUrl })
    slideshow.addSlide('zoom.png', { category: TECH_CATEGORY.collaboration, url: techUrl })

    slideshow = this.addSlideshow(SLIDESHOWS.projects, new SlideshowObj(SLIDESHOWS.projects, 150, 120, SLIDESHOWS.projects, 'Other Companies', GLOBALS.slideshowTransition))
    slideshow.addSlide('zillowThumb.png', { client: SITE_CLIENT.zillow, url: `/portfolio/${SITE_CLIENT.zillow}/splash` })
    slideshow.addSlide('firstAmThumb.png', { client: SITE_CLIENT.firstAm, url: `/portfolio/${SITE_CLIENT.firstAm}/splash` })
    slideshow.addSlide('ciandtThumb.png', { client: SITE_CLIENT.ciandt, url: `/portfolio/${SITE_CLIENT.ciandt}/splash` })
    slideshow.addSlide('crocsThumb.png', { client: SITE_CLIENT.crocs, url: `/portfolio/${SITE_CLIENT.crocs}}/splash`})
    slideshow.addSlide('fashionnovaThumb.png', { client: SITE_CLIENT.fashionnova, url: `/portfolio/${SITE_CLIENT.fashionnova}/splash` })
    slideshow.addSlide('tenxThumb.png', { client: SITE_CLIENT.tenx, url: `/portfolio/${SITE_CLIENT.tenx}/splash` })
    slideshow.addSlide('searsThumb.png', { client: SITE_CLIENT.sears, url: `/portfolio/${SITE_CLIENT.sears}/splash` })
    slideshow.addSlide('pathThumb.png', { client: SITE_CLIENT.pathfinder, url: `/portfolio/${SITE_CLIENT.pathfinder}/splash` })
    slideshow.addSlide('trThumb.png', { client: SITE_CLIENT.truven, url: `/portfolio/${SITE_CLIENT.truven}/splash` })
    slideshow.addSlide('ubsThumb.png', { client: SITE_CLIENT.ubs, url: `/portfolio/${SITE_CLIENT.ubs}/splash` })
    slideshow.addSlide('usafThumb.jpg', { client: SITE_CLIENT.usaf, url: `/portfolio/${SITE_CLIENT.usaf}/splash` })
    slideshow.addSlide('abnThumb.png', { client: SITE_CLIENT.abnAmro, url: `/portfolio/${SITE_CLIENT.abnAmro}/splash` })
    slideshow.addSlide('iesThumb.png', { client: SITE_CLIENT.ies, url: `/portfolio/${SITE_CLIENT.ies}/splash` })
    slideshow.addSlide('xbThumb.png', { client: SITE_CLIENT.xb, url: `/portfolio/${SITE_CLIENT.xb}/splash` })
    slideshow.addSlide('maytagThumb.png', { client: SITE_CLIENT.maytag, url: `/portfolio/${SITE_CLIENT.maytag}/splash` })
    slideshow.addSlide('billwhitneyThumb.jpg', { client: SITE_CLIENT.billwhitney, url: `/portfolio/${SITE_CLIENT.billwhitney}/splash` })
    slideshow.addSlide('wattsThumb.jpg', { client: SITE_CLIENT.watts, url: `/portfolio/${SITE_CLIENT.watts}/splash` })
    slideshow.addSlide('spectrumThumb.gif', { client: SITE_CLIENT.spectrum, url: `/portfolio/${SITE_CLIENT.spectrum}/splash` })
  }
}

class SlideshowObj {
  // new SlideshowObj(SLIDESHOWS.projects, 150, 120, SLIDESHOWS.projects, 'Other Companies', 2000))
  imgsArray: Array<iImageObj>
  key: string // change to slideshowKey
  width: number
  height: number
  imgsSubdir: string // The subdirectory of /publit/image/portfolio, either logos or portfolio
  title: string
  slideDur: number
  count: number
  //SLIDESHOWS.projects, 150, 120, SLIDESHOWS.projects, 'Other Companies', 2000))

  constructor(key: string, width: number, height: number, imgsSubdir: string, title: string, slideDur: number) {
    this.imgsArray = []
    this.count = 0
    this.key = key
    this.width = width
    this.height = height
    this.imgsSubdir = imgsSubdir
    this.title = title
    this.slideDur = slideDur // rename to slideDur
  }

  addSlide(file: string, data: iImageData) {
    const ddata = {width: 190, height: 150, ...data } // width and height can be overriden in the data arg
    this.imgsArray[this.count] = new ImageObj(file, ddata) // TODO change to Array.push
    this.count += 1
  }
}
export class ImageObj {
  file: string
  data: iImageData
  constructor (file:string, data:iImageData) {
    this.file = file
    this.data = data
  }
}
